import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import {materialColorOutput} from "#material/nodes/base/material/validation/io"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {z} from "zod/v4-mini"
import {color} from "@cm/graph-v3"

export interface CombineHsvSockets extends MaterialNodeSockets {
    inputs: {
        h: "float" // found in inputs: float; found in settings: float; inferred from data: float
        s: "float" // found in inputs: float; found in settings: float; inferred from data: float
        v: "float" // found in inputs: float; found in settings: float; inferred from data: float
    }
    settings: {
        color: "color" // found in inputs: -; found in settings: color; inferred from data: float3
        h: "float" // found in inputs: float; found in settings: float; inferred from data: float
        s: "float" // found in inputs: float; found in settings: float; inferred from data: float
        v: "float" // found in inputs: float; found in settings: float; inferred from data: float
    }
    outputs: {
        image: "color"
    }
}

export const combineHsvDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeCombineHSV,
    },
    nodeClass: "CombineHsv",
    ui: {
        label: "Combine HSV",
        color: "#4987af",
        items: [
            {valueType: "color", label: "Color", name: "image", output: true},
            {valueType: "float", label: "H", name: "h", range: {min: 0, max: 1}, input: true, setting: true, defaultValue: 0},
            {valueType: "float", label: "S", name: "s", range: {min: 0, max: 1}, input: true, setting: true, defaultValue: 0},
            {valueType: "float", label: "V", name: "v", range: {min: 0, max: 1}, input: true, setting: true, defaultValue: 0},
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({image: materialColorOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({h: optionalMaterialInput, s: optionalMaterialInput, v: optionalMaterialInput}),
            settings: z.strictObject({
                color: z.optional(color),
                h: z.optional(z.number()),
                s: z.optional(z.number()),
                v: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<CombineHsvSockets>
